import invert from './invert.js';
import escapeMap from './_escapeMap.js';

// Internal list of HTML entities for unescaping.
export default invert(escapeMap);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/_unescapeMap.js
// module id = 1551
// module chunks = 106